module.exports = __webpack_public_path__ + "media/images/ua-heart-03b31bd27a7029cfe67fc35212407cbf.png";